export class SettingsCache {
  private static settingsCache: SettingsCache;

  private showTooltips = true;
  private defaultPriority = 3;

  public getShowTooltips() {
    return this.showTooltips;
  }

  public setShowTooltips(input: boolean) {
    this.showTooltips = input;
    return this.showTooltips;
  }

  public getDefaultPriority(): number {
    return this.defaultPriority;
  }

  public setDefaultPriority(defaultPriority: number) {
    this.defaultPriority = defaultPriority;
  }

  public static getInstance() {
    if (this.settingsCache) {
      return this.settingsCache;
    }
    this.settingsCache = new SettingsCache();
    return this.settingsCache;
  }
}
